import Typography from '@alltrails/core/components/Typography';
import styles from './styles/OurCulture.module.scss';

type CultureStatProps = {
  title: string;
  subtitle: string;
};

const CultureStat = ({ title, subtitle }: CultureStatProps) => (
  <div className={styles.stat}>
    <Typography component="div" variant="heading500" color="primary" className={styles.title}>
      {title}
    </Typography>
    <Typography component="div" variant="text300bold" className={styles.subtitle}>
      {subtitle}
    </Typography>
  </div>
);

export { CultureStat as default };
